var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('left-side-bar'),_vm._v(" "),_c('app-nav-bar'),_vm._v(" "),_c('v-main',{attrs:{"transition":"slide-x-transition","fluid":"","pa-0":"","ma-0":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }